import React from 'react';

const SearchMessages = ({ results }) => {
  const messages = results.filter(result => result.type === 'system' || result.type === 'error');

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3 mb-6">
      {messages.map((message, index) => {
        const isError = message.type === 'error';

        return (
          <div
            key={`${message.type}-${index}-${message.content}`}
            className={`rounded-lg border px-4 py-3 text-sm leading-relaxed ${
              isError
                ? 'border-[#7f1d1d] bg-[#3b1515] text-[#fecaca]'
                : 'border-[#1f4d3c] bg-[#1d2f29] text-[#d1fae5]'
            }`}
          >
            {message.content}
          </div>
        );
      })}
    </div>
  );
};

export { SearchMessages };
